/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { apiClient } from './api';

export const getUnsubscribeTokenData = (token) => apiClient
  .get(`o/s/unsubscribe/token/${token}`)
  .then((response) => response.data.data);
